export { FindWord } from "./FIndWord";